
import * as ipxRuntime$wZjRWCZO_45CRAXTEFE_VSb6Hp3pE6dX0_45yJUgR_ycmS8 from '/var/www/marketplace-dev.ingeniuscloud.net/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "api.dapamas.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$wZjRWCZO_45CRAXTEFE_VSb6Hp3pE6dX0_45yJUgR_ycmS8, defaults: {} }
}
        